"use client";

import Image, { type ImageProps } from "next/image";
import { Button } from "@repo/ui";
import styles from "./page.module.css";
import { Tutorial } from "./components/tutorial";
import { Footer } from "./components/footer";
import { useEffect, useState } from "react";
import FantasyOnboarding from "./components/onboarding";
import Predictions from "./fantasy/pages/Predictions";
import { BrowserRouter } from "react-router-dom";
import { useCompetitionContext } from "./providers/CompetitionContext";
import { TeamProvider } from "./providers/TeamContext";

export default function Home() {
  const [userId, setUserId] = useState<string | null>(null);
  const { weekId, competitionData } = useCompetitionContext();

  useEffect(() => {
    const cookieStr = document.cookie || '';
    console.log('cookieStr', cookieStr);
    const getCookieValue = (name: string): string | null => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const popped = parts.pop();
        return popped ? popped.split(';').shift() || null : null;
      }
      return null;
    };

    // Check for authentication
    const userId = getCookieValue('userInfo');
    if (userId) {
      setUserId(userId);
    }

  }, []);

  return (
    <>
      {userId ? (
        <>Redirecting to predictions...</>
        // <BrowserRouter>
        //   <TeamProvider teamId={null} competitionData={competitionData} currentWeekId={weekId}>
        //     <Predictions weekId={weekId} user={{ token: userId }} />
        //   </TeamProvider>
        // </BrowserRouter>
      ) : (
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-center">
            <p>No user id found</p>
          </div>
        </div>
      )}
    </>
  );
}
